/**
 * Object containing methods related to the card slider.
 */
const slider = {
    _sliders: [],
    timeout: null,
    delay: 250,

    /**
     * Initializes the card slider.
     */
    init: function() {
        let self = this;
        let sliders = document.querySelectorAll('.js-slider');
        if (sliders.length === 0) return;

        window.initPackage('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js').then(function() {
            self._sliderCreate(sliders);
        })
        .catch(function(error) {
            console.error(error);
        });
      
    },

    /**
     * Creates a new Splide slider instance for each `.js-card-slider` element.
     */

    _sliderCreate(sliders) {
        let self = this;
        sliders.forEach((slider, index) => {
            if(slider.classList.contains('js-slider')) {
                self._sliders[index] = new Splide(slider, {
                    speed: 800,
                    accessibility: true,
                    arrows: false,
                    keyboard: true,
                    autoplay: true,
                    pagination: false,
                    perPage: 1,
                    focus: 'center',
                    type: 'loop',
                    pauseOnHover: false,
                    interval: 8000
                }).mount();
    
                self._initClickEvent(slider, index);
            
            }
        });
            
    },

    /**
     * Initializes click events for the `.js-slider__nav-next` and `.js-slider__nav-prev` buttons.
     */
    _initClickEvent(slider, index) {
        let self = this;

        let nextButton = slider.querySelector('.js-slider__nav-next');
        let prevButton = slider.querySelector('.js-slider__nav-prev');

        if (nextButton) {
            nextButton.addEventListener('click', () => {
                self._nextSlide(index);
            }, false);
        }

        if (prevButton) {
            prevButton.addEventListener('click', () => {
                self._prevSlide(index);
            }, false);
        }
    },

    /**
     * Goes to the next slide in the specified slider.
     */
    _nextSlide(index) {
        this._sliders[index].go('>');
    },

    /**
     * Goes to the previous slide in the specified slider.
     */
    _prevSlide(index) {
        this._sliders[index].go('<');
    },

    /**
     * Destroys all Splide slider instances and re-initializes the card slider.
     */
    reInit() {
        let self = this;
        let nodes = document.querySelectorAll('.js-card-slider');

        if (nodes.length === self._sliders.length) {
           return;
        }

        self._sliders.forEach(slider => {
            slider.destroy();
        });

        self._sliderCreate();
    },

        /**
         * Destroys all Splide slider instances.
         */
    _destroy() {
        let self = this;
        self._sliders.forEach(slider => {
            slider.destroy();
        });
        self._sliders = [];
    },

    /**
     * Updates the card slider.
     */
    _update() {
    //window.lazyLoadInstance.update();
    }
};


window.slider = slider;

window.slider.init();
